<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="账户">
                        <Input v-model="form.accountNo"></Input>
                    </FormItem>
                    <FormItem label="订单号">
                        <Input v-model="form.tradeNo"></Input>
                    </FormItem>
                </Form>
                <div  class="toolbar">
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <accountflowInfo ref="accountflowInfoRef"  @handle-search="handleSearch"></accountflowInfo>
    </div>
</template>

<script>
import accountflowInfo from './accountflow-info'
import { getIds } from '@/libs/util'

export default {
  name: 'accountflow-list',
  components: {
    accountflowInfo
  },
  data () {
    return {
      columns: [
        { title: '账户', key: 'accountNo' },
        // { title: '订单号', key: 'tradeNo' },
        { title: '交易时间', key: 'tradeTime' },
        { title: '科目', key: 'subject' },
        { title: '金额',
          key: 'money',
          render: (h, params) => {
            return h('span', (params.row.money / 100).toFixed(2))
          } },
        { title: '当前余额',
          key: 'balance',
          render: (h, params) => {
            return h('span', (params.row.balance / 100).toFixed(2))
          } },
        // { title: '原余额',
        //   key: 'beforeBalance',
        //   render: (h, params) => {
        //     return h('span', (params.row.beforeBalance / 100).toFixed(2))
        //   } },
        { title: '备注', key: 'memo' }
        // { title: '完成时间', key: 'completeTime' }
        // { title: '更新时间', key: 'updateTime' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.accountflowInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.accountflowInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.accountflowInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('trade/accountflow', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('trade/accountflow', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
